import styled from "styled-components";

export const OnErrorTitleBox = styled.div`
  width: 100%;
  padding: 1rem;
  font-size: 1.8rem;
  font-family: ${props => props.theme.font.family.medium};
  text-align: center;
  color: ${props => props.theme.colors.bodyText};
`;
